/**
 * Formats a price to display with a comma as the decimal separator and replaces “,00” with “,-”.
 * @param price - The price to be formatted.
 * @returns The price formatted as a string.
 */
export const formatNetRegularPrice = (price: number): string => {
    return price.toFixed(2).replace(".00", ",–").replace(".", ",");
};

export const formatRegularPrice = (price: number): string => {
    return price.toFixed(2).replace(".00", ",–").replace(".", ",");
};

//when the price is a string
export const formatRegularPriceString = (price: string): string => {
    return price.replace(".", ",").replace(",00", ",–");
};